import { c as _c } from "react/compiler-runtime";
import React from "react";
import styled from "styled-components";
const TooltipIconButton = styled.button.attrs({
  name: "Info om skattefradrag",
  type: "button"
})`
  z-index: 4;
  pointer-events: all;
  background: transparent;
  height: 100%;
  vertical-align: middle;
  padding: 0 10px;

  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }

  &:focus > div {
    outline: 2px solid var(--primary);
  }
`;
const TooltipInnerIcon = styled.div`
  border: 1px solid var(--primary);
  width: 2em;
  height: 2em;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  font-size: 0.8em;
  vertical-align: middle;
`;
interface ToolIconProps {
  toggleTooltip: (state: boolean) => void;
  onClick: () => void;
}
export function ToolTipIcon(t0) {
  const $ = _c(10);
  const {
    toggleTooltip,
    onClick
  } = t0;
  let t1;
  let t2;
  if ($[0] !== toggleTooltip) {
    t1 = () => setTimeout(() => toggleTooltip(false), 10);
    t2 = () => setTimeout(() => toggleTooltip(true), 20);
    $[0] = toggleTooltip;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== onClick) {
    t3 = e_0 => {
      if (e_0.pointerType === "mouse") {
        onClick();
      } else {
        if (e_0.currentTarget === document.activeElement) {
          e_0.currentTarget.blur();
          e_0.preventDefault();
        } else {
          e_0.currentTarget.focus();
          e_0.preventDefault();
        }
      }
    };
    $[3] = onClick;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <TooltipInnerIcon>?</TooltipInnerIcon>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t5 = <TooltipIconButton onPointerEnter={_temp} onBlur={t1} onFocus={t2} onPointerDown={t3} onPointerLeave={_temp2}>{t4}</TooltipIconButton>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}
function _temp2(e_1) {
  if (e_1.pointerType === "mouse") {
    e_1.currentTarget.blur();
  }
}
function _temp(e) {
  if (e.pointerType === "mouse") {
    e.currentTarget.focus();
  }
}